export enum DocumentRequestStatusEnum {
  REQUESTED = 'document_requested',
  RECEIVED = 'document_received',
  CLOSED = 'closed'
}
